module.exports = __webpack_public_path__ + "media/images/logos/logo-edone-white-277f6c216194113209494d63f4454e2d.png";